/*
 * Since the WebSDK is not yet available on npm, we asynchronously
 * load the UMD version from the appropriate env whenever the SDK is initialized
 * for the first time.
 */

const formatUmdUrl = ( env, sdkVersion ) => {
	/**
	 * When the configuration does not provide a pinned version we can omit the script version to
	 * load the latest version of the SDK.
	 *
	 * @type {string}
	 */
	const scriptVersion = sdkVersion ? `-${sdkVersion}` : '';

	return new URL(
		window.PayoneerData.webSdkUmdUrlTemplate
			?.replace( '<env>', env )
			?.replace( '<version>', scriptVersion )
	);
};

const sdkLoader = ( config ) => {
	if ( window.Payoneer?.CheckoutWeb ) {
		return window.Payoneer.CheckoutWeb( config );
	}

	return new Promise( ( resolve, reject ) => {
		const script = document.createElement( 'script' );
		script.src = formatUmdUrl( config.env, config.sdkVersion );
		script.onload = resolve;
		script.onerror = reject;

		/**
		 * Add Subresource Integrity (SRI) validation when a specific SDK version is requested.
		 * This enhances security by ensuring the loaded script matches its expected content,
		 * which is a requirement for PCI compliance.
		 */
		if ( config.sdkVersion && config.sdkIntegrity ) {
			script.integrity = config.sdkIntegrity;

			// Add crossorigin attribute when using integrity checks.
			// This is required for SRI to work properly with CORS.
			script.crossOrigin = 'anonymous';
		}
		document.head.appendChild( script );
	} ).then( () => {
		return window.Payoneer.CheckoutWeb( config );
	} );
};

export default sdkLoader;
